import editSVG from "../../../assets/icons/edit.svg";
import removeSVG from "../../../assets/icons/remove.svg";

const ActionButtons = ({
  showModal,
  showRemoveModal,
  data,
  setSelected,
  marginClass,
}) => {
  return (
    <div className="d-flex">
      <button
        className={`bg-transparent border-0 p-0 me-3 ${marginClass}`}
        onClick={() => {
          setSelected(data);
          showModal(data);
        }}
      >
        <img src={editSVG} alt="edit" />
      </button>
      <button
        className="bg-transparent border-0 p-0 m-0"
        onClick={() => {
          setSelected(data);

          showRemoveModal();
        }}
      >
        <img src={removeSVG} alt="remove" />
      </button>
    </div>
  );
};
export default ActionButtons;
